import { render, staticRenderFns } from "./SamBreadcrumbs.vue?vue&type=template&id=11edf7bc&scoped=true&"
import script from "./SamBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./SamBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./SamBreadcrumbs.vue?vue&type=style&index=0&id=11edf7bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11edf7bc",
  null
  
)

export default component.exports